"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _excluded = ["name", "label", "help", "placeholder", "images", "className", "tooltip", "disabled"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ImageGrid = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    row-gap: 10px;\n    column-gap: 10px;\n\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n\n    ", "\n\n    ", "\n"])), (0, _styledComponentsBreakpoint["default"])('tablet')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    "]))), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        grid-template-columns: repeat(4, minmax(0, 1fr));\n    "]))));

var StyledImageContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: relative;\n    padding: 10px;\n    cursor: pointer;\n    box-shadow: inset 0 0 0px 1px #ddd;\n    transition: box-shadow 0.1s ease-in-out;\n    min-height: 60px;\n\n    &.selected {\n        box-shadow: inset 0 0 0px 4px ", ";\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
});

var StyledImage = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 100%;\n"])));

var StyledDescription = _styledComponents["default"].p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    margin: 0;\n    background: rgba(255, 255, 255, 0.6);\n    padding: 10px;\n    backdrop-filter: blur(5px);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n"])));

var ImagePicker = function ImagePicker(_ref) {
  var name = _ref.name,
      label = _ref.label,
      help = _ref.help,
      placeholder = _ref.placeholder,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      tooltip = _ref.tooltip,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
        form = _ref2.form;

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
      name: name,
      label: label,
      help: help,
      tooltip: tooltip
    }, /*#__PURE__*/_react["default"].createElement(ImageGrid, null, images === null || images === void 0 ? void 0 : images.map(function (img, idx) {
      var _field$value, _img$description;

      return /*#__PURE__*/_react["default"].createElement(StyledImageContainer, {
        key: "image-".concat(idx),
        onClick: function onClick(e) {
          if (!disabled) {
            var selectedImages = field.value ? _toConsumableArray(field.value) : [];
            var imgIdx = selectedImages.indexOf(img['@id']);

            if (imgIdx > -1) {
              selectedImages.splice(imgIdx, 1);
              form.setFieldValue(name, selectedImages);
            } else {
              form.setFieldValue(name, [].concat(_toConsumableArray(selectedImages), [img['@id']]));
            }
          }
        },
        className: field !== null && field !== void 0 && (_field$value = field.value) !== null && _field$value !== void 0 && _field$value.includes(img['@id']) ? 'selected' : '',
        "data-testid": "".concat(field.name, "-image-").concat(idx)
      }, /*#__PURE__*/_react["default"].createElement(StyledImage, {
        src: img.location
      }), (img === null || img === void 0 ? void 0 : (_img$description = img.description) === null || _img$description === void 0 ? void 0 : _img$description.length) > 0 && /*#__PURE__*/_react["default"].createElement(StyledDescription, null, img.description));
    })));
  });
};

ImagePicker.displayName = 'ImagePicker';
ImagePicker.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  images: _propTypes["default"].array.isRequired,
  className: _propTypes["default"].string
};
var _default = ImagePicker;
exports["default"] = _default;